import { Heading } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

export type NameProps = {
  name: string;
};

const Name = ({ name }: NameProps) => (
  <Skeleton height="33px" width="200px">
    <Heading.h1 data-testid="ROOM_NAME" lineHeight="1.5" mb="0" fontSize="lg">
      {name}
    </Heading.h1>
  </Skeleton>
);

export default Name;
